import { Component, Input, ViewChild } from '@angular/core';
import { FooterVerticalStepComponent } from '@app/core/components/stepper/footer-vertical-step/footer-vertical-step.component';
import { LogoPlaceholderComponent } from '@app/core/components/logo-placeholder/logo-placeholder.component';
import { VerticalStepComponent } from '@app/core/components/stepper/vertical-step/vertical-step.component';
import { ChangeStepService } from './service/change-step.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { Step } from '@app/shared/interfaces/step.interface';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [LogoPlaceholderComponent, VerticalStepComponent, FooterVerticalStepComponent, CommonModule, SharedModule],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {

  @Input() brand = '';
  @Input() isPortraitDevice = false;
  @Input() isFinancialCartOpen = false;
  @ViewChild(VerticalStepComponent) verticalStepper!: VerticalStepComponent;

  steps:Step[] = [];

  steps1:Step[] = [
    {
        "stepId": 0,
        "stepNumber": 0,
        "stepName": "features.financingStart.financingTitle",
        "stepUrl": "/main/financing-start",
        "stepUrlBack": ""
    },
    {
        "stepId": 1,
        "stepNumber": 0,
        "stepName": "features.privacySettings.privacySettingsTitle",
        "stepUrl": "/main/privacy-settings",
        "stepUrlBack": "/main/financing-start"
    },
    {
        "stepId": 2,
        "stepNumber": 1,
        "stepName": "core.components.stepper.verticalStep.identification",
        "stepUrl": "/main/step/identification",
        "stepUrlBack": "/main/privacy-settings"
    },
    {
        "stepId": 3,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.personalData",
        "stepUrl": "/main/step/personal-data-info",
        "stepUrlBack": "/main/step/identification"
    },
    {
        "stepId": 4,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.personalData",
        "stepUrl": "/main/step/personal-data-birth",
        "stepUrlBack": "/main/step/personal-data-info"
    },
    {
        "stepId": 5,
        "stepNumber": 3,
        "stepName": "core.components.stepper.verticalStep.contactDataInfo",
        "stepUrl": "/main/step/contact-data-info",
        "stepUrlBack": "/main/step/personal-data-birth"
    },
    {
        "stepId": 6,
        "stepNumber": 4,
        "stepName": "core.components.stepper.verticalStep.housingData",
        "stepUrl": "/main/step/house-address",
        "stepUrlBack": "/main/step/contact-data-info"
    },
    {
        "stepId": 7,
        "stepNumber": 4,
        "stepName": "core.components.stepper.verticalStep.housingData",
        "stepUrl": "/main/step/house-type",
        "stepUrlBack": "/main/step/house-address"
    },
    {
        "stepId": 8,
        "stepNumber": 5,
        "stepName": "core.components.stepper.verticalStep.workingData",
        "stepUrl": "/main/step/working-situation",
        "stepUrlBack": "/main/step/house-type"
    },
    {
        "stepId": 9,
        "stepNumber": 5,
        "stepName": "core.components.stepper.verticalStep.workingData",
        "stepUrl": "/main/step/contract-type",
        "stepUrlBack": "/main/step/working-situation"
    },
    {
        "stepId": 10,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-first",
        "stepUrlBack": "/main/step/contract-type"
    },
    {
        "stepId": 11,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-second",
        "stepUrlBack": "/main/step/additional-data-first"
    },
    {
        "stepId": 12,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.additionalData",
        "stepUrl": "/main/step/additional-data-loan",
        "stepUrlBack": "/main/step/additional-data-second"
    },



    {
        "stepId": 17,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.secureFinancing",
        "stepUrl": "/main/secure-financing",
        "stepUrlBack": "/main/step/additional-data-second"
    },
    {
        "stepId": 18,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.coHolder",
        "stepUrl": "/main/co-holder",
        "stepUrlBack": "/main/secure-financing"
    },
    {
        "stepId": 19,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.preauthorized",
        "stepUrl": "/main/preauthorized",
        "stepUrlBack": "/main/co-holder"
    },
  ];


  steps2:Step[] = [
    {
        "stepId": 20,
        "stepNumber": 0,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 21,
        "stepNumber": 1,
        "stepName": "core.components.stepper.verticalStep.bankDetails",
        "stepUrl": "/main/step/bank-details",
        "stepUrlBack": "/main/preauthorized"
    },
    {
        "stepId": 22,
        "stepNumber": 2,
        "stepName": "core.components.stepper.verticalStep.recruitment",
        "stepUrl": "/main/step/recruitment",
        "stepUrlBack": "/main/bank-details"
    },
    {
        "stepId": 23,
        "stepNumber": 3,
        "stepName": "core.components.stepper.verticalStep.authentication",
        "stepUrl": "/main/step/authentications/authentication",
        "stepUrlBack": "/main/step/recruitment",
    },
    {
        "stepId": 24,
        "stepNumber": 3,
        "stepName": 'core.components.stepper.verticalStep.authentication',
        "stepUrl": '/main/step/authentications/authentication-data',
        "stepUrlBack": '/main/step/authentications/authentication',
    },
    {
        "stepId": 25,
        "stepNumber": 4,
        "stepName": 'core.components.stepper.verticalStep.documentationData',
        "stepUrl": '/main/step/documentation',
        "stepUrlBack": '/main/step/authentications/authentication-data',
    }
  ];


    secureFinancingStep: Step =
    {
        "stepId": 18,
        "stepNumber": 6,
        "stepName": "core.components.stepper.verticalStep.secureFinancing",
        "stepUrl": "/main/secure-financing",
        "stepUrlBack": "/main/step/additional-data-second"
    };

  preauthorizedStep: Step =
  {
      "stepId": 19,
      "stepNumber": 6,
      "stepName": "core.components.stepper.verticalStep.preauthorized",
      "stepUrl": "/main/preauthorized",
      "stepUrlBack": "/main/secure-financing"
  };


  stepIdSelected = 0;
  stepNumberSelected = 0;

  constructor(
    private changeStepService: ChangeStepService
  ) { }

  ngOnInit() {
    this.steps = this.steps1;
    this.stepIdSelected = this.changeStepService.currentStepId;

    this.stepNumberSelected = this.steps[this.stepIdSelected].stepNumber;

    this.steps = this.removeDuplicatedSteps(this.steps);

    this.changeStepService.changedStep.subscribe(stepId => {

      console.log(stepId);

      if(stepId < 20) this.steps = this.steps1;
      else this.steps = this.steps2;

      this.stepIdSelected = stepId;

      console.log(this.stepIdSelected);

      this.stepNumberSelected = Number (this.steps.find(item => (item.stepId == stepId))?.stepNumber);

      this.steps = this.removeDuplicatedSteps(this.steps);
    });
  }

  removeDuplicatedSteps(stepsList:any): any {
    let uniqueStepsList:any = [];

    stepsList.map((itemStep: Step, i: number) => {
        uniqueStepsList.filter((uniqueStep: Step) => {
            return uniqueStep.stepNumber === itemStep.stepNumber
        }).length == 0 ? uniqueStepsList.push(itemStep) : itemStep
    });
/*
    console.log(uniqueStepsList);
 */
    if(stepsList.length > 9) uniqueStepsList.push(this.secureFinancingStep);
    if(stepsList.length > 9) uniqueStepsList.push(this.preauthorizedStep);

    //console.log(uniqueStepsList);

    return uniqueStepsList;
  }

}